import { render, staticRenderFns } from "./LocateIdTag.vue?vue&type=template&id=e736c048&"
import script from "./LocateIdTag.vue?vue&type=script&lang=ts&"
export * from "./LocateIdTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports